import api from './api';

export function validateMetaMapCode(idCredit) {
    return api.get(`${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}metamap/${idCredit}/validate`)
  }

export function validateIdentitySupplier(idCredit) {
    return api.get(`${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}onboardingservices/autovalidation/${idCredit}/validate`)
  }
